import axios from '../request/http.js'

class FoodMenu {
  /* 菜单列表 */
  static getMenuList(canteenId, date) {
    let url = `/zzd/api/back/menu/list?canteenId=${canteenId}&date=${date}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 发布 */
  static postRelease(data) {
    let url = `/zzd/api/back/menu/publish`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default FoodMenu